/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const StartSocialLoginResponse = zod.object({
  providerId: zod.string().min(1).optional(),
  redirectUrl: zod.string().min(1),
  sessionTokenExchangeCode: zod.string().min(1),
});

export type StartSocialLoginResponse = zod.input<typeof StartSocialLoginResponse>;
export type StartSocialLoginResponseOutput = zod.output<typeof StartSocialLoginResponse>;
